import { Component, HostListener, inject, signal, isDevMode, DOCUMENT, PLATFORM_ID } from '@angular/core';
import { StripeComponent } from '../../../../shared/components/stripe/stripe.component';
import { CurrencyPipe, DatePipe, isPlatformBrowser } from '@angular/common';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ProductService } from '../../../../shared/service/product.service';
import { Product, ListProduct } from '../../../../core/models/product';
import { DetailsPipe } from '../../../../core/pipes/details.pipe';

import { ModalDismissReasons, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalImageLandingComponent } from '../components/modal-image-landing/modal-image-landing.component';
import { PoliticaTerminosCondicionesComponent } from '../components/politica-terminos-condiciones/politica-terminos-condiciones.component';
import { PoliticaDevolucionRembolzoComponent } from '../components/politica-devolucion-rembolzo/politica-devolucion-rembolzo.component';
import { ButtonAddItemsComponent } from '../../../../shared/components/button-add-items/button-add-items.component';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Firestore, serverTimestamp, Timestamp } from '@angular/fire/firestore';
import { GoogleAnalyticsService } from '@hakimio/ngx-google-analytics';
import { RanffleComponent } from '../../../../shared/components/ranffle/ranffle.component';
import { CarouselComponent } from '../../../../shared/components/carousel/carousel.component';
import { Meta, Title } from '@angular/platform-browser';
import { RequesStripeButtonComponent } from '../../../../shared/components/reques-stripe-button/reques-stripe-button.component'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSpinner } from '@fortawesome/pro-duotone-svg-icons';
import { faWhatsapp, faTelegram } from '@fortawesome/free-brands-svg-icons';




export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@Component({
  selector: 'app-product-home',
  imports: [StripeComponent, CurrencyPipe, DatePipe, TranslateModule, ReactiveFormsModule, ButtonAddItemsComponent, RouterLink, DetailsPipe, RanffleComponent, CarouselComponent, RequesStripeButtonComponent, FontAwesomeModule],
  templateUrl: './product-home.component.html',
  styleUrl: './product-home.component.scss',
  standalone: true,
})
export class ProductHomeComponent {
  private readonly gaService = inject(GoogleAnalyticsService);
  private modalService = inject(NgbModal);
  private readonly document = inject(DOCUMENT);
  private readonly window = this.document?.defaultView;

  platform = inject(PLATFORM_ID);
  isDevMode: boolean = isDevMode();
  iconSpinner = faSpinner;
  iconWA = faWhatsapp;
  iconTL = faTelegram;

  activeShop = false;
  product: ListProduct[] = [];
  id: string | undefined;
  admin = this.activateRoute.snapshot.queryParams['admin'];
  notProduct = false;
  currency = 'MXN';
  dateShopActive: any;
  dateShopToday: any;
  isShop = false;
  lang: any = this.window?.navigator.language;
  // .split('-')[0];
  imgPrimary: any = '';
  formQty: FormGroup;
  qty = signal(1);
  bg = {
    sofubi: false,
    artoys: false,
    blinbox: false,
    gachapon: false,
  };
  saleDone = false;
  dateActiveShop: any;
  constructor(
    private productService: ProductService,
    private activateRoute: ActivatedRoute,
    private translate: TranslateService,
    private fb: FormBuilder,
    private _doc: Title,
    private meta: Meta
  ) {
    // this.dateShopActive = new Date('05/14/24 12:30');
    // this.dateShopToday = new Date();
    // this.inputQty = this.fb.group({
    //   qty: ['', [Validators.required, Validators.min(1)]]
    // })

    // if (this.dateShopToday.getTime() > this.dateShopActive.getTime()) {
    //   this.isShop = true;
    // }
    // if (!this.lang) {
    //   this.lang = "es"
    // }

    // if (this.lang !== 'es' && this.lang !== 'en') {
    //   this.lang = 'en';
    // }
    this.formQty = this.fb.group({
      qty: [1],
    });

    this.formQty.get('qty')?.valueChanges.subscribe((res) => {
      this.qty.set(res);
    });

    // translate.addLangs(['en,es']);
    // translate.setDefaultLang(this.lang);
  }
  ngOnInit(): void {
    this.id = this.activateRoute.snapshot.params['slug'];
    console.log(this.id);
    if (!this.id || typeof this.id !== 'string' || this.id.trim() === '') {
      this.notProduct = true;
      return;
    }
    if (isPlatformBrowser(this.platform)) {
      this.document.defaultView?.scrollTo({ top: 0, behavior: 'smooth' });
    }
    this.gaService.pageView(`/product/${this.id}`, {
      title: `Pagina Product Etoy Republic -  ${this.id}`,
    });
    this.getProduct();
    // this.$gaService.pageView('/landing', 'Etoy Republic | Pagina de productos Calm Dragon');
  }
  shopProduct() {
    this.activeShop = true;
  }

  getProduct() {
    // consulta para traer el detalle del producto y ver el stock disponible
    if (!this.id) return;
    this.productService.getDetailsProduct(this.id as string, this.admin).subscribe({
      next: (res) => {
        this.product = res?.data!;
        if (res.data?.length === 0) {
          this.notProduct = true;
        } else {
          this.notProduct = false;
        }
        this.product.forEach((element) => {
          this._doc.setTitle(`Etoy Republic - ${element.name!}`)
          this.meta.updateTag({ name: 'description', content: `${element.descriptions}` });
          const now = new Date().getTime();
          this.dateActiveShop = new Date(+element.date_sale!);
          if (+now >= +element.date_sale!) {
            this.saleDone = true;
          }
          element.image?.forEach((img: any) => {
            if (img.size >= 500) {
              this.imgPrimary = { img: img.src, alt: img.alt };
            }
          });
        });
      },
    });
  }
  opemViewImg(img: any) {
    const modalRef = this.modalService.open(ModalImageLandingComponent, { size: 'lg' });
    modalRef.componentInstance.img = img;
  }
  termModal() {
    const modalRef = this.modalService.open(PoliticaTerminosCondicionesComponent, { size: 'xl' });
  }
  devoModal() {
    const modalRef = this.modalService.open(PoliticaDevolucionRembolzoComponent, { size: 'xl' });
  }
  // @HostListener('navigator', ['$event'])
  // onResize(event: any) {
  //   this.lang == navigator.language.split('-')[0];
  //   
  //   // this.screenHeight = window.innerHeight;
  // }
}
